import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/components/MenuInternal.sass';

const MenuVolcan = () => (
  <div className="row MenuInternal -volcan">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuInternal__list">
            {/* <li className="MenuInternal__list--item">
              <NavLink to="/volcan/registro">
                REGISTRO
              </NavLink>
            </li> */}
            <li className="MenuInternal__list--item">
              <NavLink to="/volcan/acerca-de-la-carrera">
                SERIES VOLCAN RESUMEN
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink id="que-incluye" to="/volcan/precios-que-incluye">
                PRECIOS Y QUÉ INCLUYE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcan/carrera-volcan">
                RUTAS
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcan/categorias">
                CATEGORÍAS
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcan/premiacion-y-reglamento">
                PREMIACIÓN Y REGLAMENTO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/volcan/patrocinio-expo">
                PATROCINIO Y EXPO
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
)
  
export default MenuVolcan;